import React, { useEffect, useState } from 'react';
import { Box } from 'rebass';
import Skeleton from 'react-loading-skeleton';

import { WhiteLabelStore } from '@plug/redux/store';
import { Image } from '@monitfy/ds';
import { OLIST_HOST_NAME } from '@plug/config/consts';
import Logo from '@plug/components/logo';

const OnboardingLogo = () => {
  const [logo, setLogo] = useState('');
  const [loading, setLoading] = useState(true);
  const isOlist = OLIST_HOST_NAME.includes(window.location.hostname);

  const { isWhiteLabel, logo: whitelabelLogo } = WhiteLabelStore.useState(s => s);

  const fetchLogo = async () => {
    try {
      const url = `https://plugone-production.nyc3.digitaloceanspaces.com/assets/logos/${window.location.hostname}/onboarding.png`;

      const response = await fetch(url);

      if (response.ok) {
        setLogo(url);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogo();
  }, []);

  const positionStyles: React.CSSProperties = {
    zIndex: 1000,
    position: 'absolute',
    top: isOlist ? '32px' : '60px',
    left: isOlist ? '132px' : '60px',
  };

  if (!isWhiteLabel && !logo && !whitelabelLogo) {
    return (
      <div style={positionStyles}>
        <Logo variant="white" width="130px" />
      </div>
    );
  }

  if (loading) {
    return <Skeleton width="100px" height="60px" />;
  }

  return (
    <Box
      maxWidth="100px"
      style={positionStyles}
      sx={{
        '@media screen and (max-width: 768px)': {
          maxWidth: '90px',
        },
      }}
    >
      <Image
        width="100%"
        src={logo || whitelabelLogo}
        skeleton={<Skeleton width="100px" height="60px" />}
        alt="Logo da organização"
      />
    </Box>
  );
};

export default OnboardingLogo;
